import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';
import Event from './class';

export const actions = {
  REQUEST: 'Dora/events-recent/REQUEST',
  RECEIVE: 'Dora/events-recent/SUCCESS',
  FAIL: 'Dora/events-recent/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'events',
  actions,
  requestDataCall: (store, params) =>
    API.get('events/?filter=recent', params).then((e) =>
      e.map((e) => new Event(e))
    ),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/events/duck.js